@if (currentModel || editingTitle) {
  <div class="matrix-overlay">
  </div>
}
@if (blockUi) {
  <aw-loading-elements heading="Loading ..."></aw-loading-elements>
}
@if (loaded) {
  <div>
    <div class="content-wrapper">
      <mat-card [ngClass]="{'editMode': editMode}">
        <div class="matrix-name">{{newMatrixName}}</div>
        <div class="matrix">
          <div class="matrix-grid definitions">
            <h2 class="matrix-title clickable" (mousedown)="cancelEditing()" (click)="editTitle(definitionTitleAlias, definitionTitle)">
              @if (!definitionTitle) {
                <span>{{sevMatrixKey + ':' + definitionTitleAlias | translate: 'Text' | async}}</span>
              }
              @if (definitionTitle) {
                <span>{{definitionTitle}}</span>
              }
            </h2>
            <div class="matrix-row matrix-header-row">
              @if (editMode) {
                <div class="edit-column first"></div>
              }
              @for (hder of definitionHeader; track hder; let i = $index; let last = $last; let alt = $odd) {
                @if (editMode) {
                  <div class="edit-column">
                    <button class="insert" (click)="insertDefinitionColumn(i)">+</button>
                  </div>
                }
                <div class="matrix-column matrix-header-column clickable"
                  (click)="selected('sevmatrix', hder, false)"
                  [class.selected]="isSelected(hder)">
                  <div class="matrix-cell" [class.alt]="alt">
                    @if (hder.description) {
                      <span>{{hder.description}}</span>
                    }
                    @if (!hder.description) {
                      <span>
                        {{'sevmatrix:' + hder.Alias | translate: 'Text' | async}}
                      </span>
                    }
                    <aw-validation-error-list [item]="hder"></aw-validation-error-list>
                  </div>
                  @if (editMode) {
                    <div class="delete-column">
                      <button class="delete" (click)="deleteDefinitionColumn(i)">x</button>
                    </div>
                  }
                </div>
                @if (editMode && last) {
                  <div class="edit-column">
                    <button class="end-insert" (click)="insertDefinitionColumn(i+1)">+</button>
                  </div>
                }
              }
            </div>
            @for (row of definitionBody; track row; let i = $index; let last = $last; let rowAlt = $odd) {
              @if (editMode) {
                <div class="edit-row">
                  <div class="edit-column">
                    <button class="insert" (click)="insertRow(i)">+</button>
                  </div>
                </div>
              }
              <div class="matrix-row" [class.row-alt]="rowAlt">
                @if (editMode) {
                  <div class="edit-column first">
                    <div class="delete-row">
                      <button class="delete" (click)="deleteRow(i)">x</button>
                    </div>
                  </div>
                }
                @for (col of row; track col; let alt = $odd; let lastCol = $last) {
                  @if (editMode) {
                    <div class="edit-column">
                    </div>
                  }
                  <div class="matrix-column clickable" [class.selected]="isSelected(col)"
                    (click)="selected('sevmatrix', col, false)" [class.alt]="alt">
                    <div class="matrix-cell">
                      @if (col.description) {
                        <span>{{col.description}}</span>
                      }
                      @if (!col.description) {
                        <span>
                          {{'sevmatrix:' + col.Alias | translate: 'Text' | async}}
                        </span>
                      }
                      <aw-validation-error-list [item]="col"></aw-validation-error-list>
                    </div>
                  </div>
                  @if (editMode && lastCol) {
                    <div class="edit-column">
                    </div>
                  }
                }
              </div>
              @if (editMode && last) {
                <div class="edit-row">
                  <div class="edit-column">
                    <button class="end-insert" (click)="insertRow(i+1)">+</button>
                  </div>
                </div>
              }
            }
          </div>
          <div class="matrix-grid configurations">
            <h2 class="matrix-title clickable" (mousedown)="cancelEditing()" (click)="editTitle(configurationTitleAlias, configurationTitle)">
              @if (!configurationTitle) {
                <span>{{sevMatrixKey + ':' + configurationTitleAlias | translate: 'Text' | async}}</span>
              }
              @if (configurationTitle) {
                <span>{{configurationTitle}}</span>
              }
            </h2>
            <div class="matrix-row matrix-header-row">
              @for (hder of configurationHeader; track hder; let i = $index; let last = $last; let alt = $odd) {
                @if (editMode) {
                  <div class="edit-column">
                    <button class="insert" (click)="insertConfigurationColumn(i)">+</button>
                  </div>
                }
                <div class="matrix-column matrix-header-column clickable"
                  (click)="selected('sevmatrix', hder, false)"
                  [class.selected]="isSelected(hder)">
                  <div class="matrix-cell" [class.alt]="alt">
                    @if (hder.description) {
                      <span>{{hder.description}}</span>
                    }
                    @if (!hder.description) {
                      <span>
                        {{'sevmatrix:' + hder.Alias | translate: 'Text' | async}}
                      </span>
                    }
                    <aw-validation-error-list [item]="hder"></aw-validation-error-list>
                  </div>
                  @if (editMode) {
                    <div class="delete-column">
                      <button class="delete" (click)="deleteConfigurationColumn(i)">x</button>
                    </div>
                  }
                </div>
                @if (editMode && last) {
                  <div class="edit-column">
                    <button class="end-insert" (click)="insertConfigurationColumn(i+1)">+</button>
                  </div>
                }
              }
            </div>
            @for (row of configurationBody; track row; let last = $last; let rowAlt = $odd) {
              @if (editMode) {
                <div class="edit-row">
                  <div class="edit-column"></div>
                </div>
              }
              <div class="matrix-row" [class.row-alt]="rowAlt">
                @for (col of row; track col; let alt = $odd; let lastCol = $last) {
                  @if (editMode) {
                    <div class="edit-column">
                    </div>
                  }
                  <div class="matrix-column clickable" draggable="true" (dragover)="savedColour && spreadColour(col)"
                    (click)="savedColour ? spreadColour(col) : selected('sevmatrix_default', col, true)">
                    <div class="matrix-cell" [class.selected]="isSelected(col)" [ngStyle]="{'background-color': col.Colour}">
                      <div>
                        @if (col.IncludedInQuery && isSeverityMatrix) {
                          <span class="circle"></span>
                        }
                      </div>
                      <div>
                        @if (col.description) {
                          <span>{{col.description}}</span>
                        }
                        @if (!col.description) {
                          <span>
                            {{'sevmatrix_default:' + col.Alias | translate: 'Text' | async}}
                          </span>
                        }
                        <aw-validation-error-list [item]="col"></aw-validation-error-list>
                      </div>
                    </div>
                  </div>
                  @if (editMode && lastCol) {
                    <div class="edit-column">
                    </div>
                  }
                }
              </div>
              @if (editMode && last) {
                <div class="edit-row">
                  <div class="edit-column">
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </mat-card>
      <div class="action-buttons">
        <input [(ngModel)]="newMatrixName" [readonly]="!isCopy" placeholder="Matrix name" />
        <button [disabled]="!newMatrixName" mat-raised-button color="accent" (click)="publish()">Publish</button>
        <button mat-raised-button class="neutral-button" (click)="fileimport.click()">Import</button>
        <div class="form-group" hidden>
          <label for="file">Import</label>
          <input type="file"
            id="file"
            #fileimport
            (change)="import($event.target.files)">
        </div>
        <button mat-raised-button class="neutral-button" (click)="export()">Export</button>
        <button mat-raised-button class="neutral-button" (click)="toggleEditMode()">insert mode toggle</button>
        <button mat-raised-button color="primary" (click)="validate()">Validate</button>
        <aw-color-swatch (selectedColour)="swatchChanged($event)" [availableColours]="availableColours"></aw-color-swatch>
      </div>
      @if (currentModel) {
        <aw-matrix-field-edit-form
          (saved)="saved($event)"
          [useScoreAndColour]="scoreAndColour"
          (cancelled)="cancelEditing()"
          [allData]="this.convertCurrentToExportDefinition()"
          [isSeverityMatrix]="isSeverityMatrix"
        [currentModel]="currentModel"></aw-matrix-field-edit-form>
      }
      @if (editingTitle) {
        <aw-title-edit-form
          (cancelled)="cancelEditing()"
          [title]="editingTitle"
        (saved)="saveTitle($event)"></aw-title-edit-form>
      }
    </div>
  </div>
}
